import { useSelector } from 'react-redux';
import { Wallet } from '@mui/icons-material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { getIcon } from '../../helpers/constant';
import PropTypes from 'prop-types';

const WalletIconWithBadge = ({
    currencyIcon,
    height,
    width,
    iconDimension,
    imageDimension,
    cryptoId,
    imageStyleClass,
    className,
}) => {
    const image_base_url = useSelector(state => state.config.image_base_url);
    const activeCurrencyPage = useSelector(state => state.juno.activeCurrencyPage);
    const Icon = activeCurrencyPage === 'crypto' ? Wallet : AccountBalanceOutlinedIcon;

    return (
        <div
            className={`relative w-${width || 8} h-${
                height || 8
            }  bg-[#E4E4E7] dark:bg-[#26272B] rounded-full flex items-center justify-center ${className}`}>
            <Icon
                sx={
                    iconDimension
                        ? {
                              height: iconDimension || 4,
                              width: iconDimension || 4,
                          }
                        : {}
                }
                className={`text-[#2d3748] dark:text-[#f7fafc]`}
            />
            <img
                src={
                    currencyIcon
                        ? `${image_base_url}${currencyIcon}`
                        : cryptoId
                          ? `${image_base_url}${getIcon(cryptoId)}`
                          : ''
                }
                alt="wallet-icon"
                className={`w-${imageDimension || 4} h-${
                    imageDimension || 4
                }  absolute -top-1 -right-1 ${imageStyleClass || ''}`}
            />
        </div>
    );
};

WalletIconWithBadge.propTypes = {
    currencyIcon: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number,
    iconDimension: PropTypes.number,
    imageDimension: PropTypes.number,
};

export default WalletIconWithBadge;
